<div class="more-details">
    <h2>Street priority levels for snow removal</h2>
</div>
<div class="d-flex justify-content-between priorities">
    <div class="priority">
        <p><strong>Priority 1</strong> streets are passable within: </p>
        <div class="priority-hours d-flex justify-content-start">
            <div class="priority-icon red">
                <i class="fas fa-road"></i>
            </div>
            <div class="priority-text">
                <h2 class="priority-hour">12 hours</h2>
                after the snowfall stopped
            </div>
        </div>
    </div>
    <div class="priority">
        <p><strong>Priority 2</strong> streets are passable within: </p>
        <div class="priority-hours d-flex justify-content-start">
            <div class="priority-icon yellow">
                <i class="fas fa-road"></i>
            </div>
            <div class="priority-text">
                <h2 class="priority-hour">48 hours</h2>
                after the snowfall stopped
            </div>
        </div>
    </div>
    <div class="priority">
        <p><strong>Priority 3</strong> streets are passable within: </p>
        <div class="priority-hours d-flex justify-content-start">
            <div class="priority-icon green">
                <i class="fas fa-road"></i>
            </div>
            <div class="priority-text">
                <h2 class="priority-hour">96 hours</h2>
                after the snowfall stopped
            </div>
        </div>
    </div>
</div>
<div class="more-details">
    <h2>How can I find out my street's priority level?</h2>
    <p>Snow removal priorities for all District streets are available on our website.</p>
    <a href="https://www.dnv.org/community-environment/preparing-and-removing-snow#fbd8f396" target="_blank">Check out
        the priority route map</a>
</div>